import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {logger} from 'redux-logger';
import rootReducer from './reducers';

function configureStore(disableLog, preloadedState) {
  const store = createStore(
    ...[rootReducer, preloadedState, disableLog ? applyMiddleware(thunk) : applyMiddleware(thunk, logger)].filter(
      Boolean,
    ),
  );

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        store.replaceReducer(rootReducer);
      });
    }
  }

  return store;
}

export default configureStore;
